import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { tanimlarApi } from '../services/api';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const token = () => localStorage.getItem('token');
const headers = () => ({ Authorization: `Bearer ${token()}` });

const AYLAR = ['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran',
               'Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'];
const GUNLER = ['Pzt','Sal','Çar','Per','Cum','Cmt','Paz'];

const RENKLER = [
  '#2E75B6','#375623','#C8A84B','#7B2C2C','#5B4FCF',
  '#1A7A6E','#C0602A','#4A7FAD','#8B5CF6','#0F766E',
];

function renkAl(id: number) { return RENKLER[id % RENKLER.length]; }

export default function ZiyaretTakvim() {
  const [ziyaretler,  setZiyaretler]  = useState<any[]>([]);
  const [isletmeler,  setIsletmeler]  = useState<any[]>([]);
  const [yoneticiler, setYoneticiler] = useState<any[]>([]);
  const [filIsletme,  setFilIsletme]  = useState('');
  const [filYonetici, setFilYonetici] = useState('');
  const [calTarih,    setCalTarih]    = useState(new Date());
  const [popup,       setPopup]       = useState<any>(null);

  const yil = calTarih.getFullYear();
  const ay  = calTarih.getMonth() + 1;

  useEffect(() => {
    tanimlarApi.isletmelerListesi(false).then(r => setIsletmeler(r.data));
    axios.get(`${API}/api/kullanicilar/`, { headers: headers() })
      .then(r => setYoneticiler(r.data)).catch(() => {});
  }, []);

  const yukle = useCallback(() => {
    const p: any = { yil, ay };
    if (filIsletme)  p.isletme_id  = filIsletme;
    if (filYonetici) p.yonetici_id = filYonetici;
    axios.get(`${API}/api/ziyaret/`, { headers: headers(), params: p })
      .then(r => setZiyaretler(r.data)).catch(() => setZiyaretler([]));
  }, [yil, ay, filIsletme, filYonetici]);

  useEffect(() => { yukle(); }, [yukle]);

  // Takvim hücreleri
  const ilkGun = new Date(yil, ay - 1, 1);
  const sonGun = new Date(yil, ay, 0);
  const baslangicHafta = (ilkGun.getDay() + 6) % 7; // Pazartesi = 0

  const hucreler: (number | null)[] = [];
  for (let i = 0; i < baslangicHafta; i++) hucreler.push(null);
  for (let d = 1; d <= sonGun.getDate(); d++) hucreler.push(d);
  while (hucreler.length % 7 !== 0) hucreler.push(null);

  const bugun = new Date();

  const gunZiyaretleri = (gun: number) =>
    ziyaretler.filter(z => {
      const d = new Date(z.baslangic);
      return d.getFullYear() === yil && d.getMonth() + 1 === ay && d.getDate() === gun;
    });

  const isletmeRenk = isletmeler.reduce((acc: any, i: any, idx: number) => {
    acc[i.id] = renkAl(idx);
    return acc;
  }, {} as Record<number, string>);

  const ileri  = () => setCalTarih(new Date(yil, ay - 1 + 1, 1));
  const geri   = () => setCalTarih(new Date(yil, ay - 1 - 1, 1));
  const bugunGit = () => setCalTarih(new Date());

  const MAX_GOSTER = 3;

  return (
    <div>
      <div className="page-header">
        <h1>📅 Ziyaret Takvimi</h1>
        <p>Aylık ziyaret planı ve takvim görünümü</p>
      </div>

      {/* Filtreler */}
      <div className="card" style={{ marginBottom: 16, padding: '12px 16px' }}>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
          <select className="search-input" style={{ width: 210 }} value={filIsletme}
            onChange={e => setFilIsletme(e.target.value)}>
            <option value="">Tüm İşletmeler</option>
            {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
          </select>
          <select className="search-input" style={{ width: 180 }} value={filYonetici}
            onChange={e => setFilYonetici(e.target.value)}>
            <option value="">Tüm Yöneticiler</option>
            {yoneticiler.map(y => <option key={y.id} value={y.id}>{y.ad_soyad}</option>)}
          </select>
          <span style={{ fontSize: 12, color: '#888', marginLeft: 'auto' }}>
            {ziyaretler.length} ziyaret
          </span>
        </div>
      </div>

      {/* Navigasyon */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 16 }}>
        <button className="btn" style={{ background: '#f0f4f8', border: '1.5px solid #e0e7ef' }} onClick={geri}>
          ← Önceki
        </button>
        <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#1a5276', minWidth: 200, textAlign: 'center' }}>
          {AYLAR[ay - 1]} {yil}
        </h2>
        <button className="btn" style={{ background: '#f0f4f8', border: '1.5px solid #e0e7ef' }} onClick={ileri}>
          Sonraki →
        </button>
        <button className="btn" style={{ background: '#eaf2fb', border: '1.5px solid #aed6f1', fontSize: 12 }} onClick={bugunGit}>
          Bugün
        </button>
      </div>

      {/* Takvim */}
      <div style={{
        display: 'grid', gridTemplateColumns: 'repeat(7,1fr)',
        border: '1px solid #e0e7ef', borderRadius: 12, overflow: 'hidden',
        background: '#fff', boxShadow: '0 1px 8px rgba(0,0,0,.05)',
      }}>
        {GUNLER.map(g => (
          <div key={g} style={{
            background: '#1a5276', color: '#fff', textAlign: 'center',
            padding: '10px 4px', fontSize: 12, fontWeight: 700, letterSpacing: 0.5,
          }}>{g}</div>
        ))}
        {hucreler.map((gun, idx) => {
          const gunZ = gun ? gunZiyaretleri(gun) : [];
          const isToday = gun !== null &&
            bugun.getFullYear() === yil &&
            bugun.getMonth() + 1 === ay &&
            bugun.getDate() === gun;

          return (
            <div key={idx} style={{
              minHeight: 120, padding: 6,
              background: gun === null ? '#f9fafb' : isToday ? '#eaf2fb' : '#fff',
              borderRight: '1px solid #e0e7ef',
              borderBottom: '1px solid #e0e7ef',
            }}>
              {gun !== null && (
                <>
                  <div style={{
                    fontSize: 12, fontWeight: isToday ? 700 : 600,
                    color: isToday ? '#1a5276' : '#888',
                    marginBottom: 4,
                  }}>{gun}</div>
                  {gunZ.slice(0, MAX_GOSTER).map(z => (
                    <div key={z.id}
                      onClick={() => setPopup(z)}
                      style={{
                        fontSize: 10, fontWeight: 600, padding: '2px 5px', borderRadius: 4,
                        marginBottom: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                        cursor: 'pointer', borderLeft: `3px solid ${isletmeRenk[z.isletme_id] || '#2E75B6'}`,
                        background: `${isletmeRenk[z.isletme_id] || '#2E75B6'}18`,
                        color: isletmeRenk[z.isletme_id] || '#2E75B6',
                      }}
                      title={`${z.isletme_kod} - ${z.yonetici_ad || 'Yönetici belirtilmemiş'}`}
                    >
                      {z.isletme_kod} {z.yonetici_ad ? `· ${z.yonetici_ad.split(' ')[0]}` : ''}
                    </div>
                  ))}
                  {gunZ.length > MAX_GOSTER && (
                    <div
                      style={{ fontSize: 10, color: '#1a5276', cursor: 'pointer', fontWeight: 600, marginTop: 2 }}
                      onClick={() => setPopup({ _liste: gunZ, _gun: gun })}
                    >
                      +{gunZ.length - MAX_GOSTER} daha
                    </div>
                  )}
                </>
              )}
            </div>
          );
        })}
      </div>

      {/* Legend */}
      {isletmeler.length > 0 && (
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 12 }}>
          {isletmeler.filter(i => ziyaretler.some(z => z.isletme_id === i.id)).map(i => (
            <div key={i.id} style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 11 }}>
              <div style={{ width: 10, height: 10, borderRadius: 2, background: isletmeRenk[i.id] }} />
              <span style={{ color: '#555' }}>{i.ad}</span>
            </div>
          ))}
        </div>
      )}

      {/* Popup - tekil ziyaret */}
      {popup && !popup._liste && (
        <div className="modal-overlay" onClick={() => setPopup(null)}>
          <div className="modal" style={{ width: 420 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>📋 Ziyaret Detayı</h3>
              <button className="modal-close" onClick={() => setPopup(null)}>×</button>
            </div>
            <div className="modal-body">
              <table style={{ width: '100%', fontSize: 13, borderCollapse: 'collapse' }}>
                <tbody>
                  {[
                    ['İşletme', `${popup.isletme_kod} — ${popup.isletme_ad}`],
                    ['Yönetici', popup.yonetici_ad || '—'],
                    ['Konu', popup.konu_ad || '—'],
                    ['Başlangıç', popup.baslangic ? new Date(popup.baslangic).toLocaleString('tr-TR') : '—'],
                    ['Bitiş', popup.bitis ? new Date(popup.bitis).toLocaleString('tr-TR') : '—'],
                    ['Süre', popup.sure_dk ? `${Math.floor(popup.sure_dk/60)}s ${popup.sure_dk%60}dk` : '—'],
                    ['Amaç', popup.amac || '—'],
                    ['Gözlemler', popup.gozlemler || '—'],
                    ['Katılımcılar', popup.katilimcilar || '—'],
                  ].map(([k, v]) => (
                    <tr key={k} style={{ borderBottom: '1px solid #f0f4f8' }}>
                      <td style={{ padding: '7px 10px', fontWeight: 600, color: '#555', width: 120 }}>{k}</td>
                      <td style={{ padding: '7px 10px', color: '#222' }}>{v}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="modal-footer">
              <button className="btn" style={{ background: '#eee' }} onClick={() => setPopup(null)}>Kapat</button>
            </div>
          </div>
        </div>
      )}

      {/* Popup - birden fazla ziyaret olan gün */}
      {popup && popup._liste && (
        <div className="modal-overlay" onClick={() => setPopup(null)}>
          <div className="modal" style={{ width: 500 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>📅 {AYLAR[ay - 1]} {popup._gun} — Ziyaretler</h3>
              <button className="modal-close" onClick={() => setPopup(null)}>×</button>
            </div>
            <div className="modal-body">
              {popup._liste.map((z: any) => (
                <div key={z.id} style={{
                  padding: '10px 12px', borderRadius: 8, marginBottom: 8,
                  background: `${isletmeRenk[z.isletme_id] || '#2E75B6'}12`,
                  borderLeft: `4px solid ${isletmeRenk[z.isletme_id] || '#2E75B6'}`,
                }}>
                  <div style={{ fontWeight: 700, fontSize: 13 }}>{z.isletme_kod} — {z.isletme_ad}</div>
                  <div style={{ fontSize: 12, color: '#555', marginTop: 2 }}>
                    {z.yonetici_ad || 'Yönetici belirtilmemiş'} · {z.konu_ad || 'Konu belirtilmemiş'}
                  </div>
                  {z.amac && <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>{z.amac}</div>}
                </div>
              ))}
            </div>
            <div className="modal-footer">
              <button className="btn" style={{ background: '#eee' }} onClick={() => setPopup(null)}>Kapat</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
